import { SET_PAYABLE_SESSION } from "actions/payableSessionActions";
import { IPayableSessionData } from "types/payableSession";

export const PayableSessionInitialState: IPayableSessionData = {
  payable: undefined,
  payableType: {
    krn: "",
    typeKrn: "",
    name: "",
    category: "",
    allowOverPayment: false,
    allowPartialPayment: false,
    allowScheduledPayment: false,
    allowScheduledPaymentOnWeekends: false,
    maxScheduledDays: undefined,
    allowCashPayment: false,
    extensionFields: [],
    lookupFields: [],
    lookups: [],
  },
  lookupResults: [],
  language: "",
  domain: "",
  channel: "",
  instanceInfo: {
    instanceId: "",
    spaceKrn: "",
    clientId: "",
    clientKrn: "",
    balanceNamespaceId: "",
    accountNamespaceId: "",
    owner: "",
    subdomain: "",
    realm: "",
    validationFields: [],
  },
  charities: [],
  paymentIntentId: "",
  fsTypes: [],
  fundingOptions: [],
  methodOfPayments: [],
  payableItemResponse: undefined,
  googlePayConfiguration: {
    publicKey: "",
    merchantId: "",
    merchantName: "",
  },
  hashId: "",
  paymentDate: "",
  barcode: undefined,
  paypalConfiguration: undefined,
  initiator: {
    principalType: "",
    principalId: "",
    principalName: "",
    deviceInfo: {
      fingerPrint: "",
      ipAddress: "",
      userAgent: "",
    },
    emailAddress: "",
  },
  paymentId: "",
  processedPayment: {
    id: "",
    paymentIntentId: "",
    account: {},
    payableDocument: {},
    donations: [],
    fundingSource: {},
    totalAmount: 0,
    paymentAmount: 0,
    feeAmount: 0,
    paymentDate: "",
    created: "",
    latestItemTransactionStatus: "",
    initiator: {},
    itemTransactions: [],
    feeTransactions: [],
    metadata: {},
    isCancellable: true,
    isFeeCancellable: true,
    isRefundable: true,
    isFeeRefundable: true,
    inDispute: true,
    payable: {},
    itemIncommConfiguration: {},
    itemIncommContext: {},
  },
};

const reducePayableSessionState = (state: any, action: any): any => {
  if (action.type === SET_PAYABLE_SESSION) {
    return {
      ...state,
      payableSession: action.payload,
    };
  } else {
    return state;
  }
};

export const payableSessionReducer = (
  state = PayableSessionInitialState,
  action: any
): any => {
  const newState = reducePayableSessionState(state, action);
  return newState;
};

export default payableSessionReducer;
